import React from 'react'
import {Paper} from '@mui/material'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import NoData from '@/components/common/NoData'

type MuiTableContainerProps = {
    maxHeight: string;
    borderRadius?: string;
    noData?: boolean;
    tableLayout?: string;
    children: React.ReactNode;
}

const MuiTableContainer = ({maxHeight, noData, children, borderRadius = ''}: MuiTableContainerProps) => {
    if(noData) {
        return <NoData/>
    }
    
    return (
        <TableContainer sx={{maxHeight: maxHeight, borderRadius: borderRadius, borderCollapse: 'collapse', boxShadow: '4px 4px 16px rgba(0, 0, 0, 0.12)' }} component={Paper}>
            <Table stickyHeader size="small">
                {children}
            </Table>
        </TableContainer>
    )
}

export default MuiTableContainer